import React, { useEffect, useState } from "react";

export default function ContractLink({ contractId }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!contractId) return;

    let isMounted = true;
    fetch(`/api/contract-link/${contractId}`)
      .then(res => res.json())
      .then(data => {
        if (isMounted && data && data.url) {
          setUrl(data.url);
        }
      })
      .catch(() => {
        if (isMounted) setUrl(null);
      });

    return () => {
      isMounted = false;
    };
  }, [contractId]);

  if (!contractId) return <>N/A</>;
  if (!url) return <>{contractId}</>;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {contractId}
    </a>
  );
}
